import { STORE_ACTIONS } from '../../actions/store';

const initialState = {
  snapshots: [] // object keyed by snapshot
};

const StoreManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_ACTIONS.DATA_REQUEST_ISSUED: {
      const newState = JSON.parse(JSON.stringify(state));

      const index = newState.snapshots.findIndex(
        s => s.slice === action.payload.slice && s.path === action.payload.path
      );
      if (index > -1) {
        newState.snapshots[index] = action.payload;
      } else {
        newState.snapshots.push(action.payload);
      }

      return newState;
    }
    case STORE_ACTIONS.DATA_REQUEST_COMPLETED:
    case STORE_ACTIONS.DATA_REQUEST_PROCESSING: {
      const newState = JSON.parse(JSON.stringify(state));
      const index = newState.snapshots.findIndex(
        s => s.slice === action.payload.slice && s.path === action.payload.path
      );
      if (index > -1) {
        newState.snapshots[index].status = action.payload.status;
        return newState;
      }

      return {
        ...state
      };
    }

    default:
      return state;
  }
};

export default StoreManagerReducer;
